<template>
  <v-dialog :value="true" persistent :max-width="490">
    <v-card class="px-6 py-4 confirmation-dialog">
      <v-card-title style="word-break: break-word" class="ma-0 pa-0 mb-3">
        <p class="ma-0 pa-0 blue-grey--text text--darken-4 h6">
          {{ $t('boards.share_board_with') }}
        </p>
      </v-card-title>
      <v-card-text class="ma-0 pa-0 mt-3">
        <AssigneesSelector
          multiple
          hideLabel
          showAdvancedOption
          :selectedAccountIds="currentSharesIds"
          :buttonText="$t('common.select_users')"
          :blacklist="[this.accountId]"
          @change="handleSharesChange"
        />
      </v-card-text>
      <v-card-actions class=" ma-0 pa-0">
        <div class="flex-grow-1">
          <Button
            plain
            color="primary"
            icon="mdi-link-variant"
            icon-position="left"
            :text="$t('boards.copy_link')"
            @click="handleCopyLink"
          />
        </div>
        <Button
          color="grey"
          plain
          class="me-3"
          :disabled="isLoading"
          :text="$t('common.button.cancel')"
          @click="handleCancel"
        />
        <Button
          color="primary"
          :loading="isLoading"
          :disabled="isLoading"
          :text="$t('common.button.save')"
          @click="handleSave"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'

import api from '@/api'
import mixin from '@/mixins/mixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import AssigneesSelector from '@/components/AssigneesSelector/AssigneesSelector.vue'

import Button from '@/components/UI/Button'

export default {
  name: 'ShareBoardModal',

  mixins: [mixin, trackerMixin],

  components: {
    Button,
    AssigneesSelector,
  },

  props: {
    boardId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      initialSharesIds: [],
      currentSharesIds: [],
    }
  },

  async mounted() {
    await this.getBoardShareList()
  },

  computed: {
    ...mapGetters(['organizationId', 'accountId']),
  },

  methods: {
    handleCancel() {
      this.trackBoardsActions('boards.CancelAction', { action: 'Share Board' })
      this.$emit('close')
    },

    async handleSave() {
      try {
        this.isLoading = true
        const usersToAdd = this.currentSharesIds.map(currentShareId => {
          return { id: currentShareId }
        })
        await api.board.share(this.organizationId, this.boardId, usersToAdd)

        const usersToRemove = this.initialSharesIds.filter(initialShareId => {
          return !this.currentSharesIds.includes(initialShareId)
        })
        if (usersToRemove.length) {
          await api.board.removeShare(
            this.organizationId,
            this.boardId,
            usersToRemove
          )
        }
        this.trackBoardsActions('boards.ShareBoard', {
          Assignees: this.currentShareIds,
        })
        this.showSuccess(this.$t('notifications.changes_saved_successfully'))
        this.$emit('save')
      } catch (err) {
        this.showError(err)
      } finally {
        this.isLoading = false
      }
    },

    handleCopyLink() {
      this.trackBoardsActions('boards.CopyLink', {
        section: 'ShareBoardModal',
      })
      const boardLink = `${window.location.origin}/boards/${this.boardId}`
      navigator.clipboard.writeText(boardLink)
      this.showSuccess(this.$t('common.link_copy_to_clipboard'))
    },

    handleSharesChange(newShares) {
      this.currentSharesIds = newShares
    },

    async getBoardShareList() {
      try {
        const response = await api.board.getShareList(
          this.organizationId,
          this.boardId
        )
        const initialSharesIds = (response?.data?.results ?? []).map(
          user => user.id
        )
        this.currentSharesIds = initialSharesIds
        this.initialSharesIds = initialSharesIds
      } catch (err) {
        this.showError(err)
      }
    },
  },
}
</script>
